<script>
  let className
  export let onImageSet

  const loadExample = (event) => {
    const base64Image = getImageAsBase64(event.target)
    onImageSet(event.target, base64Image, event.target.alt)
  }

  const getImageAsBase64 = (img) => {
    // Create an empty canvas element
    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height

    // Copy the image contents to the canvas
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)

    // Get the data-URL formatted image
    // Firefox supports PNG and JPEG. You could check img.src to
    // guess the original format, but be aware the using "image/jpg"
    // will re-encode the image.
    const dataURL = canvas.toDataURL('image/png')

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
  }
</script>

<main class={`${className || ''} print-hide examples`}>
  <p>Examples:</p>
  <div class="example-table">
    <button class="ghost" on:click={loadExample}>
      <img src="./examples/logo.png" alt="Logo" on:load={loadExample} />
    </button>
    <button class="ghost" on:click={loadExample}>
      <img src="./examples/YoshiCart.png" alt="Yoshi Cart" />
    </button>
    <button class="ghost" on:click={loadExample}>
      <img src="./examples/Mario.png" alt="Mario" />
    </button>
  </div>
</main>

<style>
  .example-table {
    overflow-y: scroll;
  }
</style>
